import { createAppWrapper } from "@/common.js";
import SessionNew from "@/sessions/Login.vue";

document.addEventListener("DOMContentLoaded", () => {
  createAppWrapper(SessionNew);
});
